module.exports = __webpack_public_path__ + "img/pav.c663ecbb.png";